import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './features/auth/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

const RupelaAdminPanel = lazy(() => import('./layouts/AdminLayout'));

function RoutesFile() {
    return (
        <ErrorBoundary>
           <BrowserRouter>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading Module...</span></div></div>}>
                <Routes>
                    <Route path='/' element={<Login />}></Route>
                    <Route path='/admin' element={
                        <ProtectedRoute>
                            <RupelaAdminPanel />
                        </ProtectedRoute>
                    }></Route>
                </Routes>
            </Suspense>
           </BrowserRouter>
           <ToastContainer position="top-right" autoClose={3000} />
        </ErrorBoundary>
    );
}

export default RoutesFile;